/*!
 * Copyright (c) Microsoft Corporation.
 * All rights reserved. See LICENSE in the project root for license information.
 */

import * as React from 'react';
import { IHeiHtmlSnippetViewProps } from './hei-html-snippet';
import MsDyn365 from '@msdyn365-commerce/core';

export default ({ config, id }: IHeiHtmlSnippetViewProps) => {
    const { externalScripts, htmlContent, className } = config;
    const divRef = React.useRef<HTMLDivElement>(null);
    const [initialized, setInitialized] = React.useState(false);

    const isBrowser = MsDyn365.isBrowser;
    React.useEffect(() => {
        const div = divRef.current;
        if (!initialized && isBrowser && div) {
            setInitialized(true);

            for (const uri of (externalScripts ?? '').split(';')) {
                if (uri) {
                    const script = document.createElement('script');
                    script.src = uri;
                    div.appendChild(script);
                }
            }

            div.innerHTML = htmlContent ?? '';
        }
    }, [isBrowser, initialized, htmlContent, externalScripts, divRef]);

    return (
        <div className={className} id={id}>
            <div ref={divRef} />
        </div>
    );
};
